import axios from "axios";
import {
  TATVA_AI_BE,
  TATVA_AI_BE_API_KEY,
  TATVA_AI_BE_API_SECRET,
} from "../../envConstants";

export const getAiCredits = async (b2c_id: string) => {
  try {
    const response = await axios.get(
      `${TATVA_AI_BE}/getcreditsb2c?userid=${b2c_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": `Drlite:${TATVA_AI_BE_API_KEY}`,
          "x-api-secret": TATVA_AI_BE_API_SECRET,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
    return {
      credit: 0,
    };
  }
};
